import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { PagosComponent } from './Pagos.component';


import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';



const routes = [
    {
        path     : 'Pagos',
        component: PagosComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'Pagos',
          nombreFormulario : 'Pagos'
        } 
    }
];

@NgModule({
    declarations: [
        PagosComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        PagosComponent
    ]
})

export class PagosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Pagos/Pagos.module.ts